import React from "react";
import themePropTypes from "../theme-prop-types";
import { DFD_TEXTAREA_MAX_LENGTH } from "../../utils/constants";

const TextArea = ({
  name,
  labelId,
  textareaId,
  value = "",
  placeholder = "",
  readonly = false,
  onChange,
  invalid,
  inputMaxLength,
  params,
  appData,
  ...props
}) => {
  const maxLength = appData.properLink
    ? DFD_TEXTAREA_MAX_LENGTH
    : inputMaxLength ||
      (placeholder.match(/max. (\d+)/) && placeholder.match(/max. (\d+)/)[1]);

  return (
    <span className='wrapper-text-area-web-sdk'>
      <textarea
        className={`text-area-web-sdk ${invalid ? "invalid" : ""}`}
        id={textareaId || `${name}-input`}
        maxLength={maxLength}
        name={name}
        rows={4}
        value={value}
        onChange={event => onChange(event, name)}
        readOnly={readonly}
        placeholder={placeholder}
        aria-labelledby={labelId || `${name}-label`}
        aria-required={params && !params.includes("TDFieldOptionIsOptional")}
        {...props}
      />

      {maxLength && (
        <span className='counter-text-area-web-sdk'>{`${value.length}/${maxLength}`}</span>
      )}
    </span>
  );
};

TextArea.propTypes = themePropTypes.input;

export default TextArea;
